export default {
      id: "circle__BLE-connect-usage",
      viewBox: "0 0 42 42",
      url: __webpack_public_path__ + "img/icons.svg#circle__BLE-connect",
      toString: function () {
        return this.url;
      }
    }